import styles from './Button.module.css'

type Color = 'black' | 'white' | 'accent' | 'disabled' | 'decline'
type Size = 'full' | 'half' | 'third'
interface ButtonProps {
  onClick?: () => void
  title: string
  backgroundColor?: Color
  disabled?: boolean
  size?: Size
  selected?: boolean
  testId?: string
}

const Button = ({
  title,
  onClick,
  backgroundColor = 'white',
  disabled,
  size = 'full',
  selected,
  testId,
}: ButtonProps) => {
  const color = disabled ? 'disabled' : styles[backgroundColor]
  const borderStyle = selected ? styles.selected : ''

  return (
    <button
      data-testid={testId}
      className={`${styles.buttonContainer} ${color} ${styles[size]} ${borderStyle}`}
      type="submit"
      onClick={onClick}
      disabled={disabled}
    >
      {title}
    </button>
  )
}

export default Button
